import Loader from "./loader";
import Router from "./router";
Loader.initialize();
Router.initialize();
